var _path, _path2, _path3, _path4, _path5, _mask, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _mask2, _g2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _mask3, _g3, _path48, _path49, _path50, _mask4, _g4, _path51, _path52, _path53, _mask5, _g5, _mask6, _g6, _mask7, _g7, _path54, _path55, _path56, _mask8, _g8, _path57, _path58, _path59, _mask9, _g9, _mask10, _g10, _mask11, _g11, _path60, _mask12, _g12, _path61, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdifyMarketplace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 241,
    viewBox: "0 0 333 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.803 0.0794264C201.592 1.38991 234.006 23.2004 258.081 52.314C282.784 82.1856 303.255 119.45 293.529 156.952C284.031 193.578 247.359 213.543 212.452 228.259C180.216 241.849 145.243 246.226 112.796 233.145C77.3177 218.842 45.2124 193.562 35.0357 156.734C24.3652 118.119 35.4865 76.4412 60.9382 45.4773C85.9608 15.0355 124.385 -1.28751 163.803 0.0794264Z",
    fill: "#C4C4C4",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.231 163.61H174.691L178 191.732H143.923L147.231 163.61Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.529 64.9624H240.364C244.019 64.9624 246.981 67.9249 246.981 71.5793V168.848C246.981 172.502 244.019 175.465 240.364 175.465H85.529C81.8746 175.465 78.9121 172.502 78.9121 168.848V71.5793C78.9121 67.9249 81.8746 64.9624 85.529 64.9624Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.962 170.998C163.657 170.998 165.842 168.813 165.842 166.118C165.842 163.423 163.657 161.238 160.962 161.238C158.267 161.238 156.082 163.423 156.082 166.118C156.082 168.813 158.267 170.998 160.962 170.998Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.753 190.077H133.171V197.025H188.753V190.077Z",
    fill: "url(#paint3_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 72,
    width: 158,
    height: 85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.356 72.6277H84.5361V156.001H241.356V72.6277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.356 72.6277H84.5361V156.001H241.356V72.6277Z",
    fill: "url(#paint4_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.175 74.8662L200.01 46.1521",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.236 75.6829L211.92 90.7469H188.1L197.784 75.6829C198.574 74.4533 200.212 74.0973 201.441 74.8877C201.76 75.0928 202.031 75.3639 202.236 75.6829Z",
    stroke: "#C7E4FF",
    strokeWidth: 3.8115
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.011 79.7883C202.661 79.7883 204.808 77.6405 204.808 74.9911C204.808 72.3416 202.661 70.1938 200.011 70.1938C197.362 70.1938 195.214 72.3416 195.214 74.9911C195.214 77.6405 197.362 79.7883 200.011 79.7883Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.808 41.6858V43.8363C204.808 46.4857 202.661 48.6335 200.011 48.6335C197.362 48.6335 195.214 46.4857 195.214 43.8363V41.6858",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1299 10.0205V184.376",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1589 9.92456H29.7907C33.4451 9.92456 36.4076 12.887 36.4076 16.5415V181.564H18.542V16.5415C18.542 12.887 21.5045 9.92456 25.1589 9.92456Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 35.0689L2 30.4371C1.99709 26.7827 4.95957 23.8202 8.61398 23.8202C8.61495 23.8202 8.61592 23.8202 8.61689 23.8231L202.588 23.9084C212.403 23.9127 220.357 31.8707 220.357 41.6858L8.61689 41.6858C4.96249 41.6858 2 38.7233 2 35.0689Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5458 180.571H7.40332V191.283H47.5458V180.571Z",
    fill: "url(#paint7_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 34.834H218.538",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 41.6858H18.542V59.5514H36.4076V41.6858Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 59.5513H18.542V77.4169H36.4076V59.5513Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2738 23.8201H36.4082V41.6857H54.2738V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.139 23.8201H54.2734V41.6857H72.139V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0043 23.8201H72.1387V41.6857H90.0043V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.87 23.8201H90.0039V41.6857H107.87V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.736 23.8201H107.87V41.6857H125.736V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.602 23.8201H125.736V41.6857H143.602V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M161.468 23.8201H143.603V41.6857H161.468V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.332 23.8201H161.467V41.6857H179.332V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.198 23.8201H179.332V41.6857H197.198V23.8201Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 77.417H18.542V95.2826H36.4076V77.417Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 95.2822H18.542V113.148H36.4076V95.2822Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 113.148H18.542V131.014H36.4076V113.148Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 131.014H18.542V148.879H36.4076V131.014Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4076 149.21H18.542V167.076H36.4076V149.21Z",
    stroke: "#FFAF7B",
    strokeWidth: 3.8115
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 86,
    width: 106,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.482 86.6204H250.405C252.232 86.6204 253.713 88.1016 253.713 89.9288V141.541C253.713 143.368 252.232 144.849 250.405 144.849H151.482C149.655 144.849 148.174 143.368 148.174 141.541V89.9288C148.174 88.1016 149.655 86.6204 151.482 86.6204Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.482 86.6204H250.405C252.232 86.6204 253.713 88.1016 253.713 89.9288V141.541C253.713 143.368 252.232 144.849 250.405 144.849H151.482C149.655 144.849 148.174 143.368 148.174 141.541V89.9288C148.174 88.1016 149.655 86.6204 151.482 86.6204Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.399 112.17L228.706 131.539C229.046 132.075 228.888 132.784 228.353 133.124C228.169 133.241 227.955 133.304 227.737 133.304H197.551C196.916 133.304 196.402 132.789 196.402 132.155C196.402 131.866 196.511 131.588 196.707 131.376L214.586 112.007C215.016 111.541 215.743 111.512 216.209 111.942C216.282 112.009 216.346 112.086 216.399 112.17Z",
    fill: "#DBFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.054 110.91C203.609 110.91 205.68 108.839 205.68 106.284C205.68 103.729 203.609 101.658 201.054 101.658C198.499 101.658 196.428 103.729 196.428 106.284C196.428 108.839 198.499 110.91 201.054 110.91Z",
    fill: "#DBFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.931 109.175L205.403 131.446C205.795 131.945 205.707 132.667 205.208 133.059C205.006 133.217 204.757 133.304 204.5 133.304H173.966C173.332 133.304 172.817 132.789 172.817 132.155C172.817 131.951 172.872 131.75 172.975 131.574L186.037 109.302C186.358 108.755 187.061 108.572 187.608 108.893C187.733 108.966 187.842 109.061 187.931 109.175Z",
    fill: "#EBFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.841 83.6426H143.045V93.9948H258.841V83.6426Z",
    fill: "url(#paint9_linear)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.991 92.5301C156.016 92.5301 156.847 91.6994 156.847 90.6746C156.847 89.6498 156.016 88.8191 154.991 88.8191C153.966 88.8191 153.136 89.6498 153.136 90.6746C153.136 91.6994 153.966 92.5301 154.991 92.5301Z",
    fill: "#F48686"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M161.773 92.5301C162.798 92.5301 163.629 91.6994 163.629 90.6746C163.629 89.6498 162.798 88.8191 161.773 88.8191C160.749 88.8191 159.918 89.6498 159.918 90.6746C159.918 91.6994 160.749 92.5301 161.773 92.5301Z",
    fill: "url(#paint10_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M168.557 92.5301C169.581 92.5301 170.412 91.6994 170.412 90.6746C170.412 89.6498 169.581 88.8191 168.557 88.8191C167.532 88.8191 166.701 89.6498 166.701 90.6746C166.701 91.6994 167.532 92.5301 168.557 92.5301Z",
    fill: "url(#paint11_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M301.907 111.976V106.848H270.146V111.976H301.907Z",
    fill: "url(#paint12_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M297.938 131.827V126.699H266.176V131.827H297.938Z",
    fill: "url(#paint13_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M291.982 151.677V146.549H260.221V151.677H291.982Z",
    fill: "url(#paint14_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M288.673 171.528V166.4H256.912V171.528H288.673Z",
    fill: "url(#paint15_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M283.71 191.379V186.251H251.949V191.379H283.71Z",
    fill: "url(#paint16_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.477 92.4988C304.991 92.4988 306.219 93.7264 306.219 95.2407C306.219 95.4552 306.194 95.669 306.144 95.8776L281.29 199.953C280.817 201.934 279.046 203.332 277.01 203.332C275.495 203.332 274.268 202.104 274.268 200.59C274.268 200.375 274.293 200.161 274.343 199.953L299.196 95.8776C299.669 93.8965 301.44 92.4988 303.477 92.4988Z",
    fill: "url(#paint17_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.009 92.499C278.524 92.499 279.751 93.7266 279.751 95.241C279.751 95.4555 279.726 95.6692 279.676 95.8779L254.823 199.953C254.349 201.934 252.579 203.332 250.542 203.332C249.027 203.332 247.8 202.104 247.8 200.59C247.8 200.375 247.825 200.162 247.875 199.953L272.729 95.8779C273.202 93.8967 274.972 92.499 277.009 92.499Z",
    fill: "url(#paint18_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M278.581 111.976V106.848H310.342V111.976H278.581Z",
    fill: "url(#paint19_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M282.551 131.827V126.699H314.312V131.827H282.551Z",
    fill: "url(#paint20_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M288.506 151.677V146.549H320.267V151.677H288.506Z",
    fill: "url(#paint21_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M291.815 171.528V166.4H323.577V171.528H291.815Z",
    fill: "url(#paint22_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M296.778 191.379V186.251H328.539V191.379H296.778Z",
    fill: "url(#paint23_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.009 92.4988C275.495 92.4988 274.267 93.7264 274.267 95.2407C274.267 95.4552 274.292 95.669 274.342 95.8776L299.196 199.953C299.669 201.934 301.44 203.332 303.477 203.332C304.991 203.332 306.219 202.104 306.219 200.59C306.219 200.375 306.194 200.161 306.144 199.953L281.29 95.8776C280.817 93.8965 279.046 92.4988 277.009 92.4988Z",
    fill: "url(#paint24_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.477 92.4988C301.963 92.4988 300.735 93.7264 300.735 95.2407C300.735 95.4552 300.76 95.669 300.81 95.8776L325.664 199.953C326.137 201.934 327.908 203.332 329.945 203.332C331.459 203.332 332.687 202.104 332.687 200.59C332.687 200.375 332.661 200.161 332.612 199.953L307.758 95.8776C307.285 93.8965 305.514 92.4988 303.477 92.4988Z",
    fill: "url(#paint25_linear)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 155,
    width: 11,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5605 155.53H58.8676V213.4H48.5605V155.53Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5605 155.53H58.8676V213.4H48.5605V155.53Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    d: "M66.6066 192.938H48.5605V195.781H66.6066V192.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5605 142.354H66.6066V172.54H48.5605V142.354Z",
    fill: "black"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.715 157.737C59.121 157.737 63.5033 153.355 63.5033 147.949C63.5033 142.543 59.121 138.161 53.715 138.161C48.3091 138.161 43.9268 142.543 43.9268 147.949C43.9268 153.355 48.3091 157.737 53.715 157.737Z",
    fill: "url(#paint27_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7155 154.573C57.3737 154.573 60.3393 151.608 60.3393 147.949C60.3393 144.291 57.3737 141.326 53.7155 141.326C50.0573 141.326 47.0918 144.291 47.0918 147.949C47.0918 151.608 50.0573 154.573 53.7155 154.573Z",
    fill: "url(#paint28_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43305,
    d: "M53.7159 151.65C55.76 151.65 57.4171 149.993 57.4171 147.949C57.4171 145.905 55.76 144.248 53.7159 144.248C51.6717 144.248 50.0146 145.905 50.0146 147.949C50.0146 149.993 51.6717 151.65 53.7159 151.65Z",
    fill: "white"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 155,
    width: 11,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6914 155.53H109.998V213.4H99.6914V155.53Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6914 155.53H109.998V213.4H99.6914V155.53Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    d: "M113.089 192.938H95.043V195.781H113.089V192.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.043 150.557H113.089V172.54H95.043V150.557Z",
    fill: "black"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.844 157.737C110.25 157.737 114.632 153.355 114.632 147.949C114.632 142.543 110.25 138.161 104.844 138.161C99.438 138.161 95.0557 142.543 95.0557 147.949C95.0557 153.355 99.438 157.737 104.844 157.737Z",
    fill: "url(#paint30_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M104.845 154.573C108.504 154.573 111.469 151.608 111.469 147.949C111.469 144.291 108.504 141.326 104.845 141.326C101.187 141.326 98.2217 144.291 98.2217 147.949C98.2217 151.608 101.187 154.573 104.845 154.573Z",
    fill: "url(#paint31_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43305,
    d: "M104.846 151.65C106.89 151.65 108.547 149.993 108.547 147.949C108.547 145.905 106.89 144.248 104.846 144.248C102.802 144.248 101.145 145.905 101.145 147.949C101.145 149.993 102.802 151.65 104.846 151.65Z",
    fill: "white"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 157,
    width: 78,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.819 157.737H40.6484V169.778H117.819V157.737Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.819 157.737H40.6484V169.778H117.819V157.737Z",
    fill: "url(#paint32_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.047 144.381L116.272 138.161L91.9376 180.31L102.712 186.53L127.047 144.381Z",
    fill: "url(#paint33_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3356 144.381L87.5615 138.161L63.2267 180.31L74.0008 186.53L98.3356 144.381Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4479 144.381L59.6738 138.161L35.339 180.31L46.1131 186.53L70.4479 144.381Z",
    fill: "url(#paint35_linear)"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 180,
    width: 78,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.819 180.979H40.6484V193.019H117.819V180.979Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.819 180.979H40.6484V193.019H117.819V180.979Z",
    fill: "url(#paint36_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.586 168.989L113.812 162.769L89.4767 204.918L100.251 211.139L124.586 168.989Z",
    fill: "url(#paint37_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8747 168.989L85.1006 162.769L60.7657 204.918L71.5398 211.139L95.8747 168.989Z",
    fill: "url(#paint38_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.987 168.989L57.2129 162.769L32.878 204.918L43.6521 211.139L67.987 168.989Z",
    fill: "url(#paint39_linear)"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 155,
    width: 11,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.482 155.53H241.789V213.4H231.482V155.53Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.482 155.53H241.789V213.4H231.482V155.53Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    d: "M249.528 192.938H231.482V195.781H249.528V192.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.482 142.354H249.528V172.54H231.482V142.354Z",
    fill: "black"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.637 157.737C242.043 157.737 246.425 153.355 246.425 147.949C246.425 142.543 242.043 138.161 236.637 138.161C231.231 138.161 226.849 142.543 226.849 147.949C226.849 153.355 231.231 157.737 236.637 157.737Z",
    fill: "url(#paint41_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M236.636 154.573C240.295 154.573 243.26 151.608 243.26 147.949C243.26 144.291 240.295 141.326 236.636 141.326C232.978 141.326 230.013 144.291 230.013 147.949C230.013 151.608 232.978 154.573 236.636 154.573Z",
    fill: "url(#paint42_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43305,
    d: "M236.637 151.65C238.681 151.65 240.338 149.993 240.338 147.949C240.338 145.905 238.681 144.248 236.637 144.248C234.593 144.248 232.936 145.905 232.936 147.949C232.936 149.993 234.593 151.65 236.637 151.65Z",
    fill: "white"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 155,
    width: 11,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.613 155.53H292.92V213.4H282.613V155.53Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.613 155.53H292.92V213.4H282.613V155.53Z",
    fill: "url(#paint43_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    d: "M296.011 192.938H277.965V195.781H296.011V192.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.155273,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.965 150.557H296.011V172.54H277.965V150.557Z",
    fill: "black"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M287.766 157.737C293.172 157.737 297.554 153.355 297.554 147.949C297.554 142.543 293.172 138.161 287.766 138.161C282.36 138.161 277.978 142.543 277.978 147.949C277.978 153.355 282.36 157.737 287.766 157.737Z",
    fill: "url(#paint44_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M287.766 154.573C291.424 154.573 294.39 151.608 294.39 147.949C294.39 144.291 291.424 141.326 287.766 141.326C284.108 141.326 281.143 144.291 281.143 147.949C281.143 151.608 284.108 154.573 287.766 154.573Z",
    fill: "url(#paint45_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43305,
    d: "M287.767 151.65C289.811 151.65 291.468 149.993 291.468 147.949C291.468 145.905 289.811 144.248 287.767 144.248C285.723 144.248 284.065 145.905 284.065 147.949C284.065 149.993 285.723 151.65 287.767 151.65Z",
    fill: "white"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 157,
    width: 78,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.741 157.737H223.57V169.778H300.741V157.737Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.741 157.737H223.57V169.778H300.741V157.737Z",
    fill: "url(#paint46_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.969 144.381L299.195 138.161L274.86 180.31L285.635 186.53L309.969 144.381Z",
    fill: "url(#paint47_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.258 144.381L270.484 138.161L246.15 180.31L256.924 186.53L281.258 144.381Z",
    fill: "url(#paint48_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.371 144.381L242.597 138.161L218.262 180.31L229.036 186.53L253.371 144.381Z",
    fill: "url(#paint49_linear)"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 180,
    width: 78,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.741 180.979H223.57V193.019H300.741V180.979Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.741 180.979H223.57V193.019H300.741V180.979Z",
    fill: "url(#paint50_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.508 168.989L296.734 162.769L272.4 204.918L283.174 211.139L307.508 168.989Z",
    fill: "url(#paint51_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.798 168.989L268.023 162.769L243.689 204.918L254.463 211.139L278.798 168.989Z",
    fill: "url(#paint52_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.91 168.989L240.136 162.769L215.801 204.918L226.575 211.139L250.91 168.989Z",
    fill: "url(#paint53_linear)"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 173,
    width: 28,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.486 175.208L153.392 210.435H126.926L137.832 175.208C138.23 173.923 139.594 173.203 140.879 173.601C141.647 173.839 142.248 174.44 142.486 175.208Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.486 175.208L153.392 210.435H126.926L137.832 175.208C138.23 173.923 139.594 173.203 140.879 173.601C141.647 173.839 142.248 174.44 142.486 175.208Z",
    fill: "url(#paint54_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21 202.468H125.432V208.846H158.21V202.468Z",
    fill: "url(#paint55_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.297526,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.942 187.049C139.161 187.049 140.149 188.037 140.149 189.256C140.149 189.407 140.133 189.558 140.103 189.706L135.297 212.792H129.869L134.675 189.706C134.997 188.158 136.361 187.049 137.942 187.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21 189.711H125.432V196.09H158.21V189.711Z",
    fill: "url(#paint56_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21 176.954H125.432V183.333H158.21V176.954Z",
    fill: "url(#paint57_linear)"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.095 208.847H154.222C155.507 208.847 156.548 209.888 156.548 211.172C156.548 212.457 155.507 213.498 154.222 213.498H126.095C124.811 213.498 123.77 212.457 123.77 211.172C123.77 209.888 124.811 208.847 126.095 208.847Z",
    fill: "url(#paint58_linear)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "mask11",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 173,
    width: 28,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.453 175.208L211.359 210.435H184.893L195.798 175.208C196.196 173.923 197.561 173.203 198.846 173.601C199.614 173.839 200.215 174.44 200.453 175.208Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.453 175.208L211.359 210.435H184.893L195.798 175.208C196.196 173.923 197.561 173.203 198.846 173.601C199.614 173.839 200.215 174.44 200.453 175.208Z",
    fill: "url(#paint59_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.175 202.468H183.396V208.846H216.175V202.468Z",
    fill: "url(#paint60_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.297526,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.906 187.049C197.125 187.049 198.113 188.037 198.113 189.256C198.113 189.407 198.097 189.558 198.067 189.706L193.26 212.792H187.833L192.639 189.706C192.961 188.158 194.325 187.049 195.906 187.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.175 189.711H183.396V196.09H216.175V189.711Z",
    fill: "url(#paint61_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.176 176.955H183.397V183.333H216.176V176.955Z",
    fill: "url(#paint62_linear)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.062 208.847H212.189C213.473 208.847 214.515 209.888 214.515 211.172C214.515 212.456 213.473 213.498 212.189 213.498H184.062C182.777 213.498 181.736 212.456 181.736 211.172C181.736 209.888 182.777 208.847 184.062 208.847Z",
    fill: "url(#paint63_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.939,
    y1: 352.414,
    x2: 159.939,
    y2: 148.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 86.4125,
    y1: 105.921,
    x2: 308.029,
    y2: 287.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 160.669,
    y1: 226.764,
    x2: 160.669,
    y2: 156.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 135.651,
    y1: 193.519,
    x2: 228.377,
    y2: 207.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 272.53,
    y1: 100.101,
    x2: 88.007,
    y2: 188.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 188.2,
    y1: 33.0449,
    x2: 226.395,
    y2: 96.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 202.767,
    y1: 43.338,
    x2: 193.567,
    y2: 60.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 40.542,
    y1: 186.241,
    x2: 16.2076,
    y2: 179.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 200.944,
    y1: 99.8453,
    x2: 234.084,
    y2: 157.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 200.943,
    y1: 74.565,
    x2: 200.943,
    y2: 116.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 164.367,
    y1: 88.4363,
    x2: 159.32,
    y2: 92.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 171.15,
    y1: 88.4363,
    x2: 166.104,
    y2: 92.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 251.698,
    y1: 109.32,
    x2: 310.947,
    y2: 116.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 247.728,
    y1: 129.17,
    x2: 306.977,
    y2: 136.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 241.773,
    y1: 149.021,
    x2: 301.022,
    y2: 156.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 238.463,
    y1: 168.872,
    x2: 297.712,
    y2: 175.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 233.5,
    y1: 188.722,
    x2: 292.749,
    y2: 195.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 288.917,
    y1: 233.421,
    x2: 319.178,
    y2: 103.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E62FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 262.45,
    y1: 233.421,
    x2: 292.71,
    y2: 103.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E62FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 328.791,
    y1: 109.32,
    x2: 269.968,
    y2: 116.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B497FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 332.76,
    y1: 129.171,
    x2: 273.511,
    y2: 136.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 338.715,
    y1: 149.021,
    x2: 279.466,
    y2: 156.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 342.025,
    y1: 168.872,
    x2: 282.776,
    y2: 175.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 346.988,
    y1: 188.723,
    x2: 287.739,
    y2: 195.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A887FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 292.252,
    y1: 267.709,
    x2: 246.185,
    y2: 67.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E62FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 318.719,
    y1: 267.709,
    x2: 272.653,
    y2: 67.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E62FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 53.7728,
    y1: 216.302,
    x2: 48.3841,
    y2: 152.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 60.0877,
    y1: 156.004,
    x2: 47.2822,
    y2: 141.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 69.4859,
    y1: 171.882,
    x2: 50.6131,
    y2: 145.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 104.904,
    y1: 216.301,
    x2: 99.5149,
    y2: 152.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 111.217,
    y1: 156.004,
    x2: 98.4111,
    y2: 141.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 120.616,
    y1: 171.882,
    x2: 101.743,
    y2: 145.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: -27.531,
    y1: 162.016,
    x2: 84.1681,
    y2: 224.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 116.452,
    y1: 149.549,
    x2: 74.7548,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 87.7415,
    y1: 149.549,
    x2: 46.0439,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 59.8538,
    y1: 149.549,
    x2: 18.1562,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: -27.531,
    y1: 185.257,
    x2: 84.1681,
    y2: 247.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 113.991,
    y1: 174.158,
    x2: 72.2939,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 85.2806,
    y1: 174.158,
    x2: 43.5829,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 57.3929,
    y1: 174.158,
    x2: 15.6952,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 236.695,
    y1: 216.301,
    x2: 231.306,
    y2: 152.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 243.01,
    y1: 156.004,
    x2: 230.204,
    y2: 141.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 252.407,
    y1: 171.882,
    x2: 233.534,
    y2: 145.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 287.825,
    y1: 216.302,
    x2: 282.437,
    y2: 152.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 294.139,
    y1: 156.004,
    x2: 281.333,
    y2: 141.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 303.537,
    y1: 171.882,
    x2: 284.664,
    y2: 145.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 155.391,
    y1: 162.016,
    x2: 267.09,
    y2: 224.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 299.375,
    y1: 149.549,
    x2: 257.678,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 270.664,
    y1: 149.549,
    x2: 228.967,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 242.777,
    y1: 149.549,
    x2: 201.079,
    y2: 273.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 155.391,
    y1: 185.257,
    x2: 267.09,
    y2: 247.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 296.914,
    y1: 174.158,
    x2: 255.217,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 268.203,
    y1: 174.158,
    x2: 226.506,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 240.316,
    y1: 174.158,
    x2: 198.618,
    y2: 297.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 126.121,
    y1: -27.5684,
    x2: 162.961,
    y2: 218.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 126.894,
    y1: 205.585,
    x2: 193.272,
    y2: 222.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 126.894,
    y1: 192.828,
    x2: 193.272,
    y2: 209.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 126.894,
    y1: 180.071,
    x2: 193.272,
    y2: 196.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 94.8102,
    y1: 210.616,
    x2: 144.168,
    y2: 235.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 184.088,
    y1: -27.5684,
    x2: 220.928,
    y2: 218.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 184.859,
    y1: 205.585,
    x2: 251.237,
    y2: 222.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 184.859,
    y1: 192.828,
    x2: 251.237,
    y2: 209.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 184.86,
    y1: 180.072,
    x2: 251.238,
    y2: 196.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2C2A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 152.777,
    y1: 210.616,
    x2: 202.135,
    y2: 235.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45664"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdifyMarketplace);
export default __webpack_public_path__ + "static/media/edifyMarketplace.01ddf123.svg";
export { ForwardRef as ReactComponent };